import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { toast } from "react-toastify";
import { AddToCart, get_cart } from "../../actions/orders";
import Close from "../../assets/cancel.svg";
import Tyre from "../../assets/coming-soon.jpg";
import CartPopup from "../Cart/CartPopup";
import { Quantity } from "../Cart/Products";
import { NavWrap, season_icons } from "../ShopForTyres";
import "../styles/order.css";

const ProductDetails = () => {
  const history = useHistory();
  const [product, setProduct] = useState({});
  const [selectedImgIdx, setSelectedImgIdx] = useState(0);
  const location = useLocation();
  const addToCart = useSelector((state) => state?.orders?.addToCart);
  const cart = useSelector((state) => state?.orders?.cart?.data?.cart);
  const dispatch = useDispatch();
  useEffect(() => {
    let obj = {
      email: localStorage.getItem("email"),
    };
    dispatch(get_cart(obj));
    if (location?.state?.product) setProduct(location?.state?.product);
    // eslint-disable-next-line
  }, [location.state]);

  useEffect(() => {
    if (addToCart.success) {
      toast.success("Product added to cart.");
      localStorage.setItem("cartId", addToCart?.data?.cart?.id);
      let obj = {
        email: localStorage.getItem("email"),
      };
      dispatch(get_cart(obj));
      dispatch({
        type: AddToCart.RESET,
      });
    }
    if (addToCart.success === false) {
      toast.error("Failed to add product in cart.");
      dispatch({
        type: AddToCart.RESET,
      });
    }
    // eslint-disable-next-line
  }, [addToCart]);

  useEffect(() => {
    if (cart?.line_items) {
      let line_item = cart?.line_items?.find(
        (ele) => ele?.SKU === product?.sku
      );
      setProduct((prod) => ({ ...prod, Quantity: line_item?.Quantity }));
    }
    // eslint-disable-next-line
  }, [cart]);

  const sortedFileNames = (a, b) => {
    // Extract numeric parts and convert to integers
    let numA = parseInt(a?.name?.match(/\d+/)?.[0], 10);
    let numB = parseInt(b?.name?.match(/\d+/)?.[0], 10);

    return numA - numB;
  };

  return (
    <NavWrap>
      <div className="cart">
        <span className="close">
          <img
            src={Close}
            className="cursor"
            alt="close"
            onClick={() => {
              history.push("/shop-for-tyres");
            }}
          />
        </span>
        <div className="order-detail">
          <CartPopup />
          <div className="d-flex gap1">
            <div className="d-flex gap1 w50 left">
              <div className="w15">
                {product?.images?.sort(sortedFileNames)?.map((ele, i) => (
                  <span
                    className={selectedImgIdx === i ? "active" : ""}
                    onClick={() => {
                      setSelectedImgIdx(i);
                    }}
                  >
                    <img src={ele.url ? ele.url : Tyre} alt="tyre" />
                  </span>
                ))}
              </div>
              <div className="w85">
                <span>
                  <img
                    src={
                      product?.images?.[selectedImgIdx]?.url
                        ? product?.images?.[selectedImgIdx]?.url
                        : Tyre
                    }
                    alt="tyre"
                  />
                </span>
              </div>
            </div>
            <div className="w50 right">
              <div className="ml2">
                <div className="head-sec p-relative">
                  <span>{product?.brand}</span>
                  <strong>{product?.pattern}</strong>
                  <span className="dim">Product SKU : {product?._originalSku}</span>
                  {/* <div style={{
                    position: "absolute",
                    right: "6rem"
                  }}>
                    <span>Production Status : {product?.prod_status}</span>
                  </div> */}
                </div>
                <div className="price-sec">
                  <strong>${parseFloat(product?.unit_price).toFixed(2)}</strong>
                </div>
                <div className="selected-rim">
                  <div>
                    <label>Selected Rim</label>
                    {/* <span>Size Chart</span> */}
                  </div>
                  <button className="primary-btn">{product?.rim}''</button>
                </div>
                <hr />
                <div className="selected-rim flex-start mb1">
                  <button className="primary-btn">{product?.size}</button>
                  {/* <span>See more tyre size</span> */}
                </div>
                <div className="selected-rim flex-start">
                  <Quantity fromDetail={true} data={product} />
                </div>
                <div className="product-detail mt2">
                  <h3>Product Detail</h3>
                  <p>

                  </p>
                  <ul>
                    <li><strong className="mrHalf">Season:</strong><img className={`season-img ${product?.season?.trim()?.toLowerCase()}`} src={season_icons[product?.season?.trim()?.toLowerCase()]} alt="" /></li>
                    <li><strong className="mrHalf">Application:</strong>{product?.application}</li>
                    {/* <li><strong className="mrHalf">Group:</strong>{product?.mtr_group}</li> */}
                    <li><strong className="mrHalf">EAN:</strong>{product?.ean}</li>
                    <li><strong className="mrHalf">SW:</strong>{product?.sidewall}</li>
                    {/* <li><strong className="mrHalf">Size:</strong>{product?.size}</li> */}
                    <li><strong className="mrHalf">Pattern:</strong>{product?.pattern}</li>
                    <li><strong className="mrHalf">LI:</strong>{product?.li}</li>
                    <li><strong className="mrHalf">SR:</strong>{product?.sr}</li>
                    <li><strong className="mrHalf">LR:</strong>{product?.lr}</li>
                    <li><strong className="mrHalf">Brand:</strong>{product?.brand}</li>
                    {/*                     
                    <li><strong className="mrHalf">Warranty:</strong>{product?.rh_warranty}</li>
                    <li><strong className="mrHalf">Guarantee:</strong> {product?.s_guarantee}</li> */}
                    <li>{product?.certifications}</li>
                    {/* <li>SUV / Light Truck</li>
                    <li>Mud and Snow</li> */}
                  </ul>
                  {/* <ul className="links">
                    <li>Limited Warrent</li>
                    <li>Contact Us</li>
                  </ul> */}
                </div>
                {/* <div className="tabs mt1">
                  <Tabs defaultActiveKey="1">
                    <TabPane tab="Description" key="1">
                      <p>
                        The Patriot A/T is an all-terrain tyre that has been
                        designed for on and off-road use. This range offers
                        steering stability and traction in mud and snow
                        conditions while maintaining good on-road performance as
                        well.
                        <br />
                        <br />
                        The Patriot A/T is an all-terrain tyre that has been
                        designed for on and off-road use. This range offers
                        steering stability and traction in mud and snow
                        conditions while maintaining good on-road performance as
                        well.
                      </p>
                    </TabPane>
                    <TabPane tab="Sizes" key="2">
                      Content of Tab Pane 2
                    </TabPane>
                    <TabPane tab="Specification" key="3">
                      Content of Tab Pane 3
                    </TabPane>
                    <TabPane tab="Warrenty" key="4">
                      Content of Tab Pane 4
                    </TabPane>
                  </Tabs>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </NavWrap>
  );
};

export default ProductDetails;
